import Vue from 'vue'
import Router from 'vue-router'

/*一级路由*/
import Index from '@/views/Index'
import Layout from '@/views/Layout'

/*二级路由*/
import Home from '@/components/Home'
import Manual from '@/components/Manual'
import Book from '@/components/Book'
import Wechat from '@/components/Wechat'
import About from '@/components/About'
import Login from '@/components/Login'
import Register from '@/components/Register'

Vue.use(Router);
const router = [{
    path: '*', //没有配置的路径
    redirect: '/', //默认跳转首页
    meta: {
      // 页面标题 title
      title: 'MK 导航'
    }
  },
  {
    path: '/',
    name: 'index',
    components: { //一个页面里，多个路由容器vue-router
      default: Index,
    },
    meta: {
      // 页面标题 title
      title: '导航主页',
    }
  },
  {
    path: '/index',
    name: 'indexLink',
    component: Index,
    meta: {
      title: '导航主页'
    }
  },
  {
    path: '/', // 一级路由
    name: 'layoutLink',
    component: Layout,
    children: [ // 二级路由
      {
        path: '/home',
        name: 'homeLink',
        component: Home,
        meta: {
          title: '首页'
        }
      },
      {
        path: '/manual',
        name: 'manualLink',
        component: Manual,
        meta: {
          title: '手册'
        }
      },
      {
        path: '/book',
        name: 'bookLink',
        component: Book,
        meta: {
          title: '书籍'
        }
      },
      {
        path: '/wechat',
        name: 'wechatLink',
        component: Wechat,
        meta: {
          title: '公号'
        }
      },
      {
        path: '/about',
        name: 'aboutLink',
        component: About,
        meta: {
          title: '关于'
        }
      },
      {
        path: '/login',
        name: 'loginLink',
        component: Login,
        meta: {
          title: '登录'
        }
      },
      {
        path: '/register',
        name: 'registerLink',
        component: Register,
        meta: {
          title: '注册'
        }
      }
    ]
  },
];
export default new Router({
  routes: router,
  mode: "history",
  /*滚动行为*/
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; //按后退键，滚动条停留在上一次浏览的位置
    } else {
      return {
        x: 0,
        y: 0
      } //路由跳转时，滚动条的坐标位置
    }
    // return {selector:'.btn'}     //滚动条浏览在指定目标位置
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js